
    import HeadingSection from '../../components/MainComponent/HeadingSection.vue';
    import Team from '../../components/AboutUs/Team.vue';
    import ProjectsSection from '../../components/MainComponent/ProjectsSection.vue';
    import PageSections from '../../components/AboutUs/PageSections.vue';

    export default {
        components: {
            ProjectsSection,
            Team,
            HeadingSection,
            PageSections,
        },
        computed: {
            aboutUsPageData() {
                return this.$store.state.aboutUsPageData;
            },
        },
        async asyncData(context) {
            await context.app.$getDataFromCache(`/wp-json/wp/v2/pages/11`)
                .then((response) => {
                    context.store.dispatch("setAboutUsPageData", response.data.acf);
                });
            await context.store.dispatch("setPageChangeAnimationValueFalse");
        },
    };
